import { render, staticRenderFns } from "./DialogAddContactToGroup.vue?vue&type=template&id=77d3425b&scoped=true&"
import script from "./DialogAddContactToGroup.vue?vue&type=script&lang=ts&"
export * from "./DialogAddContactToGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d3425b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
